module.exports = __webpack_public_path__ + "static/img/icon_3.398006d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_3.png
// module id = rbNc
// module chunks = 0